import React from 'react';
import { GroupChannelMessageRenderer } from '@sendbird/uikit-react-native';
import type { SendbirdFileMessage, SendbirdUserMessage } from '@sendbird/uikit-utils';
import { useChatMessageView } from '../../hooks/useChatMessageView';
import type { TChatMessageRendererProps } from '../../types';
import { adaptPrevMessageForNameGrouping } from '../../utils/messageGrouping';
import { ChatAdminMessage } from '../cards/ChatAdminMessage';
import { ChatTextMessage } from '../cards/ChatTextMessage';
import { ChatDaySeparator } from '../layout/ChatDaySeparator';
import { ChatEmptyConversation } from '../layout/ChatEmptyConversation';

export const ChatMessageRenderer = ({
    message,
    prevMessage: rawPrevMessage,
    ...props
}: TChatMessageRendererProps) => {
    const view = useChatMessageView({ message, prevMessage: rawPrevMessage, nextMessage: props.nextMessage });

    if (view.kind === 'hidden') return null;
    if (view.kind === 'emptyConversation') return <ChatEmptyConversation />;

    return (
        <>
            <ChatDaySeparator message={message} prevMessage={view.prevMessage} />
            {view.kind === 'admin' && message.isAdminMessage() && <ChatAdminMessage message={message} />}
            {view.kind === 'bubble' && (
                <ChatTextMessage
                    message={message as SendbirdUserMessage | SendbirdFileMessage}
                    prevMessage={view.prevMessage}
                    attachment={view.attachment}
                    isMine={view.isMine}
                    onPress={view.onPressDocument ?? props.onPress}
                    onLongPress={props.onLongPress}
                />
            )}
            {view.kind === 'native' && (
                <GroupChannelMessageRenderer
                    {...props}
                    message={message}
                    prevMessage={adaptPrevMessageForNameGrouping(message, view.prevMessage)}
                    nextMessage={undefined}
                />
            )}
        </>
    );
};
